import { useEffect } from 'react';
import {
  extend,
  useDataModel,
  string,
  params,
  bool
} from '@thd-nucleus/data-sources';
import PropTypes from 'prop-types';
import { SalientPoints } from '@thd-olt-component-react/salient-points';
import { ProductModel } from '../../../models/product';

export const FulfillmentData = ({ onData, itemId, storeId }) => {

  const opts = {
    variables: {
      itemId,
      storeId,
    },
    ssr: false
  };
  const { data } = useDataModel('product', opts);
  useEffect(() => {
    if (data) {
      onData(data);
    }
  }, [data, onData]);

  return null;
};

FulfillmentData.propTypes = {
  onData: PropTypes.func,
  itemId: PropTypes.string,
  storeId: PropTypes.string,
};

FulfillmentData.defaultProps = {
  onData: null,
  itemId: null,
  storeId: null,
};

FulfillmentData.dataModel = extend({
  product: params({
    itemId: string().isRequired(),
  }).shape(ProductModel)
}, SalientPoints);